function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.65863249,9.79755061 C7.37870246,10.0674831 6.93881241,10.0674831 6.66887988,9.79755061 C6.66887988,9.79755061 6.66887988,9.79755061 6.66887988,9.79755061 L2.3899494,5.51862034 C2.12001687,5.24868783 2.12001687,4.8087978 2.3899494,4.53886528 C2.3899494,4.53886528 2.3899494,4.53886528 2.3899494,4.53886528 L6.71886738,0.209947513 C6.78884989,0.139965009 6.8688299,0.079980005 6.95880741,0.0499875031 C7.04878492,0.0199950012 7.12876493,0 7.21874244,0 C7.40869496,0 7.58864998,0.0699825044 7.70862,0.199950012 C7.97855253,0.47988003 7.97855253,0.919770057 7.70862,1.18970257 L3.86957956,5.02874281 L7.64863499,8.80779805 C7.91856752,9.07773057 7.91856752,9.51762059 7.65863249,9.79755061 Z",
  id: "prev-icon"
});

var SvgPrev = function SvgPrev(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "0.625rem",
    height: "0.6875rem",
    viewBox: "0 0 8 10",
    fill: "currentColor",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrev, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/prev.45383b01.svg";
export { ForwardRef as ReactComponent };